<template>
    <form ref="form" @submit.prevent>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">센터관리</span>
            <span class="txt">센터의 이름, 주소, 전화번호 등 센터의 기본정보를 설정합니다.</span>
        </div>

        <div class="com-table-top">
            <div class="logo-area">
                <div class="logo-box">
                    <span class="logo">
                        <img :src="data.logoUrl" alt="" />
                    </span>
                </div>
                <div class="info-box">
                    <span class="location">{{ data.centerName }}</span>
                    <span class="address">
                        {{ data.address }} {{ data.addressDetail }} /
                        {{ `${data.telNo1 || ''}-${data.telNo2 || ''}-${data.telNo3 || ''}` }}
                    </span>
                    <span v-if="data.centerType == 'M'" class="type">본사</span>
                    <span v-else class="type">지점</span>
                </div>
            </div>
        </div>

        <div class="com-tab">
            <span v-for="(item, index) in submenus" :key="index">
                <router-link :class="{ on: $route.name == item.name }" :to="{ ...item, params: { centerId } }">
                    {{ item.label }}
                </router-link>
            </span>
        </div>

        <div class="radio-info-content">
            <span class="title">센터별 교차수강</span>
            <p class="detail-txt">
                여러 지점을 운영하는 경우, 구매한 지점과 상관없이 다른 지점에서 사용(예약)할 수 있는지 여부를
                설정합니다.
                <br />
                <br />
                A지점에서 구매 후 B지점에서 사용 시,
                <br />
                소진매출은 A지점에 적용되고, 급여는 B지점의 수업한 강사에게 지급됩니다.
            </p>
            <div class="info-area">
                <div class="left-box w775">
                    <div class="input-line">
                        <span class="tit">센터별 교차수강을 가능하도록 하시겠습니까?</span>
                        <div class="line">
                            <div class="com-radio">
                                <input
                                    id="radio-1-1"
                                    v-model="data.crossLessonYn"
                                    :value="true"
                                    checked
                                    name="radio-1"
                                    type="radio"
                                />
                                <label for="radio-1-1">가능</label>
                            </div>
                            <div class="com-radio">
                                <input
                                    id="radio-1-2"
                                    v-model="data.crossLessonYn"
                                    :value="false"
                                    name="radio-1"
                                    type="radio"
                                />
                                <label for="radio-1-2">불가능</label>
                            </div>
                        </div>
                    </div>
                    <div v-if="data.crossLessonYn" class="radio-info">
                        <span class="tit">교차수강이 가능한 센터를 선택해주세요. (중복체크 가능)</span>
                        <div class="check-cnt">
                            <div v-for="(item, index) in chains" :key="index" class="check-line">
                                <div class="com-check">
                                    <input
                                        :id="`check-${index}`"
                                        v-model="item.crossLessonYn"
                                        :value="true"
                                        name="check-1"
                                        type="checkbox"
                                    />
                                    <label :for="`check-${index}`">
                                        {{ item.centerName }} {{ item.chainSpotName }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <p class="notice-txt">
                            *센터간에 협의가 되셨나요?
                            <br />
                            협의가 되지 않은 수업사용(예약)에 대해 핏투데이케어에서는 책임지지 않습니다.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="bottom-btn">
            <button :disabled="isLoading" class="com-btn blue" type="button" @click="save">저장</button>
        </div>
    </form>
</template>

<script>
import axios from 'axios';
import api from '../../../assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';

export default {
    name: 'SettingCenterLecture',
    components: { LoadingSpinner },
    props: ['centerId'],
    computed: {},
    data() {
        return {
            isLoading: false,
            data: {},
            chains: [],
            submenus: [
                { name: 'SettingCenterEdit', label: '기본정보' },
                { name: 'SettingCenterProgram', label: '프로그램 가입내역' },
                { name: 'SettingCenterHoliday', label: '휴일설정' },
                { name: 'SettingCenterAccount', label: '정산설정' },
                { name: 'SettingCenterLecture', label: '교차수강설정' },
            ],
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        load() {
            if (!this.centerId) return;
            this.isLoading = true;
            axios
                .all([
                    api.get(`/admin/api/center/${this.centerId}`),
                    api.get(`/admin/api/center/${this.centerId}/chain`),
                ])
                .then(
                    axios.spread((...res) => {
                        this.isLoading = false;
                        this.data = res[0].data;
                        const telNo = (this.data.telNo || '').match(/(\d{2,3})(\d{3,4})(\d{4})/);
                        if (telNo) {
                            this.data.telNo1 = telNo[1];
                            this.data.telNo2 = telNo[2];
                            this.data.telNo3 = telNo[3];
                        }

                        this.chains = res[1].data;
                    })
                )
                .catch((res) => {
                    this.isLoading = false;
                    this.data = {};
                    if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        save() {
            if (!this.$refs.form.checkValidity() || this.isLoading) {
                return;
            }

            const data = {
                centers: this.chains.map((o) => {
                    return {
                        centerId: o.id,
                        crossLessonYn: this.data.crossLessonYn && o.crossLessonYn,
                    };
                }),
                crossLessonYn: this.data.crossLessonYn,
            };

            this.isLoading = true;
            api.put(`/admin/api/center/${this.centerId}/cross-lesson`, data)
                .then((res) => {
                    this.isLoading = false;
                    alert('저장했습니다.');
                })
                .catch((res) => {
                    this.isLoading = false;
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
    },
};
</script>
<style lang="scss"></style>
